import { render, staticRenderFns } from "./LogoEmpresas.vue?vue&type=template&id=5b89e571"
import script from "./LogoEmpresas.vue?vue&type=script&lang=js"
export * from "./LogoEmpresas.vue?vue&type=script&lang=js"
import style0 from "./LogoEmpresas.vue?vue&type=style&index=0&id=5b89e571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports